import { PERMISSION_MATRIX } from "../config/orgPermissionMatrix";

/**
 * แปลง path จาก location / NavItem ให้เทียบคีย์ read ได้สม่ำเสมอ
 */
export function normalizePath(pathname) {
  if (!pathname || typeof pathname !== "string") return "/";
  let p = pathname.trim().toLowerCase();
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return p || "/";
}

function buildExactPathToReadKey() {
  const m = new Map();
  PERMISSION_MATRIX.forEach((sec) => {
    sec.pages.forEach((p) => {
      if (!p.path) return;
      m.set(normalizePath(p.path), p.read);
    });
  });
  return m;
}

const EXACT_PATH_TO_READ_KEY = buildExactPathToReadKey();

/**
 * prefix ยาวสุดก่อน — ใช้กับหน้าย่อยที่ไม่ได้ใส่ในเมทริกซ์แบบ exact
 * ค่าเป็น page.*.read
 */
const PREFIX_READ_KEY_RULES = [
  ["/sale-call-detail", "page.sale_report.read"],
  ["/sale-appoint-detail", "page.sale_report.read"],
  ["/sale-call-report", "page.sale_report.read"],
  ["/sale-appoint-report", "page.sale_report.read"],
  ["/admin/quote", "page.sale_quote.read"],
  ["/contract/create", "page.sale_contract.read"],
  ["/contract/edit", "page.sale_contract.read"],
  ["/contract/view", "page.sale_contract.read"],
  ["/contract-sign", "page.sale_contract.read"],
  ["/contractlist", "page.sale_contract.read"],
  ["/quotelist", "page.sale_quote.read"],
  ["/quote", "page.sale_quote.read"],
  ["/editcustomer", "page.sale_customer.read"],
  ["/history", "page.sale_customer.read"],
  ["/job-management", "page.job_management.read"],
  ["/job/calendar", "page.job_management.read"],
  ["/job/list", "page.job_management.read"],
  ["/job/close", "page.job_management.read"],
  ["/jobfile", "page.job_file.read"],
  ["/stock/stock-form-adjust", "page.stock_management.read"],
  ["/stock/stock-form-transfer", "page.stock_management.read"],
  ["/stock/stock-form-count", "page.stock_management.read"],
  ["/stock", "page.stock_overview.read"],
].sort((a, b) => b[0].length - a[0].length);

export function parseOrgAccess() {
  try {
    return JSON.parse(localStorage.getItem("org_access") || "{}");
  } catch {
    return {};
  }
}

/** ผู้ใช้ที่ต้องบังคับสิทธิ์จาก Tb_Comp_Role_Permission */
export function isPermissionEnforced() {
  const org = parseOrgAccess();
  return org.scoped === true && org.legacy !== true;
}

/**
 * คีย์ read ที่ path นี้ผูกกับ (หรือ null ถ้าไม่ map — ไม่บังคับในเมนู)
 */
export function resolveReadKeyForPath(pathname) {
  const path = normalizePath(pathname);
  const exact = EXACT_PATH_TO_READ_KEY.get(path);
  if (exact) return exact;
  for (const [prefix, readKey] of PREFIX_READ_KEY_RULES) {
    if (path === prefix || path.startsWith(`${prefix}/`)) return readKey;
  }
  return null;
}

/**
 * มีสิทธิ์ read สำหรับ path นี้หรือไม่ (เมนู / redirect)
 * - role_code 1,2: ผ่านทั้งหมด
 * - ไม่ใช่ scoped หรือ legacy: ไม่กรองจาก matrix
 * - path ไม่มีใน map: ผ่าน (หน้าเก่า/อื่น)
 */
export function hasPathReadAccess(pathname) {
  const roleCode = localStorage.getItem("role_code");
  if (roleCode === "1" || roleCode === "2") return true;
  const org = parseOrgAccess();
  if (!org.scoped || org.legacy) return true;
  const readKey = resolveReadKeyForPath(pathname);
  if (!readKey) return true;
  const perms = org.permissions;
  if (!Array.isArray(perms) || perms.length === 0) return false;
  return new Set(perms).has(readKey);
}

/**
 * เช็คคีย์สิทธิ์ดิบ (เช่น page.sale_customer.update) — ให้ตรงกับ hasOrgPermission ฝั่ง backend
 */
export function hasOrgPermissionKey(permissionKey) {
  if (!permissionKey) return true;
  const roleCode = localStorage.getItem("role_code");
  if (roleCode === "1" || roleCode === "2") return true;
  const org = parseOrgAccess();
  if (!org.scoped || org.legacy) return true;
  const perms = org.permissions;
  if (!Array.isArray(perms) || perms.length === 0) return false;
  return new Set(perms).has(permissionKey);
}
